import clsx from 'clsx';

import { PlacementDocument } from './singleStudent.types';
import { StudentDocumentCard } from './StudentDocumentCard';
import { groupDocumentsByMonth } from './StudentDocuments.utils';

type StudentDocumentsListProps = {
  documents: PlacementDocument[];
};

export const StudentDocumentsList = ({ documents }: StudentDocumentsListProps) => {
  return (
    <div className="space-y-8">
      {groupDocumentsByMonth(documents).map(({ month, documents: monthDocuments }, index) => (
        <div key={month}>
          <h3
            className={clsx(
              ' text-body-lg-desktop text-neutral-200',
              index === 0 ? 'mb-6' : 'mb-3',
            )}
          >
            {month}
          </h3>
          <div className="space-y-3">
            {monthDocuments.map((document) => (
              <StudentDocumentCard key={document.id} document={document} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
